export default __webpack_public_path__ + "static/media/Sanchi1_N-MP-220.6da2b241.jpg";